import { Injectable } from '@angular/core';
import { AssignmentsApi } from '../api/assignments.api';
import { BulkAssignmentTemplateType } from '../model/enum/assignments/bulk-assignment-template-type.enum';
import { AssignmentsRequestDTO } from '../model/assignments/assignments-request-dto.model';

@Injectable()
export class AssignmentsService {

    constructor(private assignmentsApi: AssignmentsApi) { }

    getAssignments = (assignmentRequest: AssignmentsRequestDTO) => 
        this.assignmentsApi.getAssignments(assignmentRequest);

    removeBuildingAssignments = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.removeBuildingAssignments(buildingAssignments);

    addBuildingAssignments = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.addBuildingAssignments(buildingAssignments);

    addBuildingLeads = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.addBuildingLeads(buildingAssignments);

    removeBuildingLeads = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.removeBuildingLeads(buildingAssignments);

    downloadBulkUpdateTemplate = (templateType: BulkAssignmentTemplateType) =>
        this.assignmentsApi.downloadBulkUpdateTemplate(templateType);

    bulkUpdatePreview = (file: File) => this.assignmentsApi.bulkUpdatePreview(file);

    bulkUpdate = (file: File) => this.assignmentsApi.bulkUpdate(file);
}
